import { login, logout } from '@/api/auth'
import { getCustomerInfo } from '@/api/common'
import cryptoaes from '@/utils/cryptoaes'
import storage from '@/utils/storage'
import { getStores, getUserAuthoritys } from '@/api/user'
import { GetLeftMenuOrderTotalCount } from '@/api/order/order'

let authoritys = storage.getLocal('authoritys')
if (authoritys) {
  try {
    authoritys = JSON.parse(authoritys)
  } catch (error) {
    /*  */
  }
}
authoritys = authoritys || []

let menuIds = storage.getLocal('menuIds')
if (menuIds) {
  try {
    menuIds = JSON.parse(menuIds)
  } catch (error) {
    /*  */
  }
}
menuIds = menuIds || []



const user = {
  state: {
    // 登录标志
    hasLogin: false,
    // 用户数据
    userInfo: {},
    // 账号
    account: {},
    // token
    token: {},
    // 名称
    name: '',
    // 头像
    avatar: '',
	userName: '',

    stores: [],

    isDefault: false, // 主账户
    authoritys,
	menuIds,
	isAdmin: false
  },

  mutations: {
    // 写登录标志
    SET_HASLOGIN: (state, value) => {
      state.hasLogin = value
    },
    // 写用户信息
    SET_USERINFO: (state, value) => {
      state.userInfo = value
    },
    // 写token
    SET_TOKEN: (state, token) => {
      state.token = token
      storage.setCookie('jdkey', token ? cryptoaes.encrypt(JSON.stringify(token)) : '')
    },
    SET_AUTHORITYS(state, authoritys) {
      state.authoritys = authoritys
      storage.setLocal('authoritys', authoritys)
    },
	SET_menuIds(state, menuIds) {
	  state.menuIds = menuIds
	  storage.setLocal('menuIds', menuIds)
	},
    // 写名称
    SET_NAME: (state, name) => {
      state.name = name
    },
    // 写头像
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },

    SET_STORES: (state, stores) => {
      state.stores = stores
    },

    SET_ACCOUNT: (state, account) => {
      state.account = account
      state.isDefault = account.isDefault || false
    },
	SET_USERNAME: (state, name) => {
		state.userName = name
	},
	SET_isAdmin: (state, name) => {
		state.isAdmin = name
	}
  },

  actions: {
    // 登录
    async LogIn({ commit, dispatch }, loginParam) {
      const res = await login(loginParam)
      if (res.code && res.code === 200 && res.msg) {
        // 提交上面的mutaions方法
        commit('SET_HASLOGIN', true)
        var token = {
          tokenHead: 'Bearer',
          accessToken: res.msg
        }
        commit('SET_TOKEN', token)
        const { data } = await dispatch('GetUserInfo')
        // if (!data.account.isDefault) {
        //   await dispatch('GetUserAuthoritys')
        // }
      } else {
        console.log(res)
        throw res
      }
    },
    // 设置token
    SetToken({ commit }, token) {
      // 提交上面的mutaions方法
      commit('SET_TOKEN', token)
    },
    async GetLeftMenuOrderTotalCount({ commit }) {
      const { data } = await GetLeftMenuOrderTotalCount()
      commit('SET_BADGE', { DropshippingOrders: data })
    },
    // 获取用户信息
    GetUserInfo({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        getCustomerInfo().then(async (res) => {
          if (res.code === 200 && res.data) {
            // 提交上面的mutaions方法
            commit('SET_HASLOGIN', true)
            const userInfo = res.data.customer ?? {}
            // userInfo.isVip = true
            commit('SET_USERINFO', userInfo)
			commit('SET_USERNAME', res.data.userName)
			commit('SET_isAdmin', res.data.isAdmin)
            commit('SET_ACCOUNT', res.data.account || {})
            commit('SET_NAME', res.data.customer.name ?? '匿名用户')
            commit('SET_AVATAR', '')
            dispatch('GetLeftMenuOrderTotalCount')
            if (userInfo.allianceRebate > 0) {
              commit('SET_ROUTER_HIDE', { name: 'Affiliate', value: 0 })
            } else {
              commit('SET_ROUTER_HIDE', { name: 'Affiliate', value: 1 })
            }
			if (!res.data.account.isDefault) {
				await dispatch('GetUserAuthoritys')
			}
            resolve(res)
          } else {
            // dispatch('LogOut')
            reject(res)
          }
        })
      })
    },

    async GetUserAuthoritys({ commit }) {
      try {
        const { data } = await getUserAuthoritys()
        const authoritys = data.authoritys ? data.authoritys.split(',') : []
        commit('SET_AUTHORITYS', authoritys)
		const menuIds = data.menuIds ? data.menuIds.split(',') : []
		commit('SET_menuIds', menuIds)
      } catch (error) {
        /*  */
        console.error(error)
      }
    },

    // 退出系统
    LogOut({ commit }) {
      logout()
      // 提交上面的mutaions方法
      commit('SET_HASLOGIN', false)
      commit('SET_TOKEN', {})
      commit('SET_USERINFO', {})
      commit('SET_NAME', '')
      commit('SET_AVATAR', '')
      storage.removeCookie('jdkey')
    },

    async getStores({ commit }) {
      const { data } = await getStores()
      commit('SET_STORES', data || [])
    }
  }
}

export default user
